import { render, staticRenderFns } from "./veHqHaopinShow.vue?vue&type=template&id=4bf0161e&scoped=true"
import script from "./veHqHaopinShow.vue?vue&type=script&lang=js"
export * from "./veHqHaopinShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf0161e",
  null
  
)

export default component.exports